(function() {
  var IrrigationDetailsBase,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  IrrigationDetailsBase = App.loadClass('grower::Angular/IrrigationDetailsBase');

  exports.IrrigationDetailsController = (function(superClass) {
    extend(IrrigationDetailsController, superClass);

    function IrrigationDetailsController(scope, transitions, validation, service, ngModal) {
      this.scope = scope;
      this.transitions = transitions;
      this.validation = validation;
      this.service = service;
      this.ngModal = ngModal;
      this.copy = bind(this.copy, this);
      this.showOnMap = bind(this.showOnMap, this);
      this.validate = bind(this.validate, this);
      IrrigationDetailsController.__super__.constructor.call(this, this.scope, this.transitions);
      this.scope.copy = this.copy;
      this.scope.field_data = this.validation.getFieldData();
      this.scope.validate = this.validate;
      this.scope.validationService = this.validation;
      this.scope.validationService.setStepScope(this.scope);
      this.scope.validation = this.validation.validate;
      this.showOnMap(this.scope.field_data.zones.irrigation);
      this.alwaysRequiredInputs = ['irrigation_method_id', 'water_source_id', 'irrigation_water_conservation', 'tail_water_recovery', 'use_pumps'];
      if (this.scope.field_data.zones.irrigation.details != null) {
        this.scope.details = this.scope.field_data.zones.irrigation.details;
      } else if (this.scope.field_data.zones.irrigation.copied != null) {
        this.scope.details = this.scope.field_data.zones.irrigation.copied;
      } else {
        this.scope.details = {
          irrigation_method_id: null,
          irrigation_water_conservation: null,
          tail_water_recovery: null,
          use_pumps: null,
          energy_source: null,
          pump_pressure: null,
          pumping_depth: null,
          water_source_id: null,
          secondary_irrigation: false,
          secondary_use_pumps: null,
          secondary_energy_source: null,
          secondary_pump_pressure: null,
          secondary_pumping_depth: null
        };
      }
      this.service.getMethods().then((function(_this) {
        return function(response) {
          return _this.scope.irrigation_methods = response.data.data;
        };
      })(this));
      this.service.getSources().then((function(_this) {
        return function(response) {
          _this.scope.energy_sources = response.data;
          _this.setLoadedEnergySource();
          return _this.scope.validationService.validate();
        };
      })(this));
      this.service.getWaterSources().then((function(_this) {
        return function(response) {
          _this.scope.water_sources = response.data;
          _this.scope.secondaryIrrigationWaterSourceId = _this.scope.water_sources.find(function(source) {
            return source.name === "Both Surface Water and Deep Aquifer Groundwater";
          }).id;
          return _this.scope.validationService.validate();
        };
      })(this));
      this.scope.$on('$destroy', (function(_this) {
        return function() {
          var area, i, len, ref, results;
          ref = _this.scope.field_data.zones.irrigation.zones;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            area = ref[i];
            results.push(App.map.removeLayer(area.visible));
          }
          return results;
        };
      })(this));
      this.validation.setBackButtonDisable(this.scope.field_data, false);
      this.scope.validationService.validate();
    }

    IrrigationDetailsController.prototype.validate = function(ending) {
      var detail, key, ref, ref1, ref2;
      if ((this.scope.details == null) || !this.scope.water_sources) {
        return false;
      }
      if (indexOf.call((function() {
        var ref, results;
        ref = this.scope.details;
        results = [];
        for (key in ref) {
          detail = ref[key];
          if (indexOf.call(this.alwaysRequiredInputs, key) >= 0) {
            results.push(detail != null);
          }
        }
        return results;
      }).call(this), false) >= 0) {
        return false;
      }
      if (this.scope.details.use_pumps === true && ((this.scope.details.energy_source == null) || (this.scope.details.pump_pressure == null) || (this.scope.details.pumping_depth == null))) {
        return false;
      }
      if (((ref = this.scope.details) != null ? ref.secondary_use_pumps : void 0) === true && ((this.scope.details.secondary_energy_source == null) || (this.scope.details.secondary_pump_pressure == null) || (this.scope.details.secondary_pumping_depth == null))) {
        return false;
      }
      if (((ref1 = this.scope.details) != null ? ref1.water_source_id : void 0) === this.scope.water_sources.find((function(_this) {
        return function(source) {
          return source.name === 'Both Surface Water and Deep Aquifer Groundwater';
        };
      })(this)).id && (((ref2 = this.scope.details) != null ? ref2.secondary_use_pumps : void 0) == null)) {
        return false;
      }
      this.scope.field_data.zones.irrigation.details = this.scope.details;
      return true;
    };

    IrrigationDetailsController.prototype.showOnMap = function(zones) {
      var area, geojson, i, len, ref, results;
      ref = zones.zones;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        area = ref[i];
        geojson = area.visible.toGeoJSON();
        area.visible.clearLayers();
        L.geoJson(geojson).eachLayer((function(_this) {
          return function(l) {
            l.setStyle({
              weight: 2,
              color: area.color,
              fillOpacity: 0.6
            });
            area.visible.addLayer(l);
            return _this.validation.pgis.added_layers.push(l);
          };
        })(this));
        results.push(area.visible.addTo(App.map));
      }
      return results;
    };

    IrrigationDetailsController.prototype.copy = function() {
      if (this.validate()) {
        return this.ngModal.openCopyIrrigationDetailsDialog(parseInt(this.scope.field_data.id), parseInt(this.scope.field_data.year), this.scope.details);
      }
    };

    return IrrigationDetailsController;

  })(IrrigationDetailsBase);

}).call(this);
